/*
 * Copyright (C) 2019. Archimedes Exhibitions GmbH,
 * Saarbrücker Str. 24, Berlin, Germany
 *
 * This file contains proprietary source code and confidential
 * information. Its contents may not be disclosed or distributed to
 * third parties unless prior specific permission by Archimedes
 * Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
 * to copies made in any form and using any medium. It applies to
 * partial as well as complete copies.
 */

import Vue from 'vue'
import { BootstrapVue, BVToastPlugin, IconsPlugin } from 'bootstrap-vue'

import BptcMediaAppDriver from 'bptc-mediaappdriver'
// import BptcMediaAppDriver from './plugins/bptcmediaappdriver-js'
import PowervisorDriver from 'powervisordriver'

import brokerGrpcWebPb from 'emsapis/broker/v1/broker_grpc_web_pb'

import App from './App.vue'
import router from './router'
import DriverManager from './js/drivermanager'
import KeyCloakManager from './js/keycloakmanager'
import cms from 'bptc-cms'
import powervisor from 'powervisorweb'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/_globals.scss'

const initAuth = async () => {
  let kcres = await fetch(process.env.BASE_URL + '/keycloak.json')
  let kcconf = await kcres.json()
  let kcmgnr = new KeyCloakManager(kcconf)
  Vue.prototype.$keycloakmanager = kcmgnr
  kcmgnr.addLoginCallback(initApp)
  kcmgnr.init()
}

const initApp = async () => {
  let response = await fetch(process.env.BASE_URL + '/config.json')
  let config = await response.json()

  let domain = window.location.protocol + '//' + window.location.hostname
  Vue.prototype.$BROKER_PROXY = (
    domain + config.brokerProxy
  )
  Vue.prototype.$TIMELINE_MONGODB = (
    domain + config.timelineMongoDb
  )
  Vue.prototype.$SUPPORT_EMAIL = (
    config.supportEmail
  )

  Vue.config.productionTip = false

  Vue.use(BootstrapVue)
  Vue.use(BVToastPlugin)
  Vue.use(IconsPlugin)

  Vue.use(BptcMediaAppDriver)
  Vue.use(PowervisorDriver)

  // Config cms
  response = await fetch(process.env.BASE_URL + '/cmsconfig.json')
  let cmsConfig = await response.json()
  cmsConfig.timelinePath = config.timelineMongoDb
  let route = {
    path: '/content',
    component () {
      return import(/* webpackChunkName: "clientTypes" */ './views/Content.vue')
    }
  }
  Vue.use(cms, {
    config: cmsConfig,
    route: route,
    keycloakManager: (
      Vue.prototype.$keycloakmanager.isConfigured ? Vue.prototype.$keycloakmanager : null
    )
  })
  router.addRoutes([route])
  // End config cms

  // Config powervisor
  const appres = await fetch(process.env.BASE_URL + 'pvconfig.json')
  const appconf = await appres.json()
  Vue.use(powervisor, {
    config: appconf,
    keycloakManager: Vue.prototype.$keycloakmanager
  })
  // End powervisor config

  Vue.prototype.$driverManager = new DriverManager(
    Vue.prototype.$BROKER_PROXY,
    brokerGrpcWebPb,
    config.brokerTimeout
  )

  Vue.prototype.$VUE_APP_VERSION = require('../package').version

  new Vue({
    router,
    render (h) { return h(App) }
  }).$mount('#app')
}

initAuth()
